import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(
  theme => ({
    root: {
      textAlign: "left",
      width: window.location.pathname.includes("solo")
        ? "100%"
        : "calc(100% - 20px)",
    },
    cardContainer: {
      width: "100%",
    },
    header: {
      display: "grid",
      marginBottom: 22,
      margin: "0 -5px",
      [theme.breakpoints.down("xs")]: {
        marginBottom: "12px",
      },
    },
    headerItem: {
      fontWeight: "bold",
      textTransform: "uppercase",
      padding: "0px 5px",
      color: "#00003D",
      [theme.breakpoints.down("xs")]: {
        fontSize: "12px",
      },
    },
    bar: {
      borderRadius: 5,
      padding: 5,
      marginBottom: 6,
      // width: "100%",
    },
    itemBar: {
      // width: "100%",
      backgroundColor: "#FFF0EF",
      display: "grid",
      position: "relative",
    },
    itemBarNotSaved: {
      backgroundColor: "#FFF0EF",
      display: "grid",
      position: "relative",
      border: "1px solid red",
    },
    itemsGroup: {
      marginBottom: theme.spacing(2),
    },
    item: {
      padding: 5,
      fontSize: "1rem",
      // minHeight: 32,
      display: "flex",
      alignItems: "center",
      [theme.breakpoints.down("xs")]: {
        fontSize: "12px",
      },
    },
    roleGroup: {
      marginBottom: 17,
      [theme.breakpoints.down("xs")]: {
        fontSize: "12px",
      },
    },
    roleBarNotSaved: {
      backgroundColor: "#FAF7F7",
      display: "grid",
      position: "relative",
      border: "1px solid red",
    },
    roleBar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      backgroundColor: "#FAF7F7",
      [theme.breakpoints.down("xs")]: {
        flexWrap: "wrap",
        flexDirection: "column",
        padding: "10px",
      },
    },
    textFieldNotSaved: {
      padding: 5,
      backgroundColor: "#fff",
      border: "2px solid red",
      borderRadius: "5px",
      textAlign: "left",
      [theme.breakpoints.down("xs")]: {
        fontSize: "12px",
      },
    },
    textField: {
      padding: 5,
      backgroundColor: "#fff",
      textAlign: "left",
      [theme.breakpoints.down("xs")]: {
        fontSize: "12px",
      },

    },

    textFieldInput: {
      '& .MuiInputBase-root-997': {
        padding: "0px"
      }
    },


    commissionTextField: {
      padding: 5,
      backgroundColor: "#fff",
      textAlign: "left",
      width: "90px",
      [theme.breakpoints.down("xs")]: {
        fontSize: "12px",
      },
    },
    autoCompleteUnderline: {
      "&:before": {
        border: ["none", "!important"],
      },
      "&:after": {
        border: ["none", "!important"],
      },
    },
    autocomplete: {
      height: "29px",
      borderRadius: "5px",
    },
    classesAutocomplete: {
      padding: "5px",
    },
    saveButton: {
      color: theme.palette.error.main,
      font: "normal normal normal 12px/15px Helvetica",
      letterSpacing: "0px",
      opacity: 1,
      height: "25px",
      width: "59px",
      marginLeft: "5px",
      [theme.breakpoints.down("xs")]: {
        height: "20px",
        width: "30px",
        fontSize: "12px",
      },
    },
    deleteButton: {
      font: "normal normal normal 13px/15px Helvetica",
      letterSpacing: "0px",
      color: "#9A9A9A",
      opacity: 1,
      height: 25,
      [theme.breakpoints.down("xs")]: {
        height: "20px",
        width: "30px",
        fontSize: "12px",
      },
    },
    addButton: {
      color: theme.palette.error.main,
      fontSize: "16px",
      font: "normal normal bold 13px/16px Helvetica",
      letterSpacing: "0px",
      opacity: 1,
      padding: 0,
    },
    flagButton: {},
    redFlag: {
      color: theme.palette.error.main,
    },
    rejectedText: {
      color: theme.palette.error.main,
    },

    roleBarChildren: {
      display: "flex",
      alignItems: "center",
      marginLeft: "15px",
      [theme.breakpoints.down("xs")]: {
        minWidth: "100%",
        marginLeft: "initial",
        justifyContent: "space-between",
      },
    },

    iconButton: {
      padding: "0px 0px 0px 5px",
      height: "29px",
      width: "29px",
      borderRadius: "0px",
    },
  }),
  {
    name: "ExpenseTable",
  }
)

export default styles
